import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TrCheckboxModule } from "@toro/common/shared/components";
import { WithoutSuitabilityDisclaimerComponent } from './without-suitability-disclaimer.component';
import { SvgIconModule } from '@toro/common/shared/components/svg-icon/svg-icon.module';

@NgModule({
    imports: [
        TrCheckboxModule,
        FormsModule,
        ReactiveFormsModule,
        SvgIconModule
    ],
    declarations: [WithoutSuitabilityDisclaimerComponent],
    exports: [WithoutSuitabilityDisclaimerComponent]
})

export class WithoutSuitabilityDisclaimerModule {}